/** Director display order only; never reorder enrollment or seating data in place. */
export function comparePeople(a: { firstName: string; lastName: string }, b: { firstName: string; lastName: string }) {
  return a.firstName.localeCompare(b.firstName, 'en', { sensitivity: 'base' })
    || a.lastName.localeCompare(b.lastName, 'en', { sensitivity: 'base' });
}
